import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/Select";
import { cn } from "@/lib/utils";
import { forwardRef } from "react";
import { Controller } from "react-hook-form";

const SelectInput = forwardRef(
  (
    {
      error,
      className,
      placeholder,
      items,
      valueKey = "value",
      nameKey = "name",
      errorMessage,
      onValueChange = () => {},
      ...props
    },
    ref
  ) => {
    return (
      <div className="flex-1">
        <Controller
          ref={ref}
          {...props}
          render={({ field }) => {
            const { ref: fieldRef, ...otherFields } = field;
            return (
              <Select
                onValueChange={e => {
                  field.onChange(e);
                  onValueChange(e);
                }}
                {...otherFields}
              >
                <SelectTrigger className="mt-1 w-full" ref={fieldRef}>
                  <SelectValue placeholder={placeholder} />
                </SelectTrigger>
                <SelectContent
                  className={cn("mb-2 overflow-auto max-h-[350px]", className)}
                >
                  {items?.map(item => (
                    <SelectItem key={item[valueKey]} value={item[valueKey]}>
                      {item[nameKey]}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            );
          }}
        />

        {(error || errorMessage) && (
          <span className="text-destructive text-sm pt-1 block">
            {error?.message || errorMessage}
          </span>
        )}
      </div>
    );
  }
);

SelectInput.displayName = "SelectInput";

export default SelectInput;
